import { Trans } from "@lingui/react/macro";
import { Button, Divider, Group, Stack, Text } from "@mantine/core";
import { IconBolt, IconLogout, IconMail, IconSettings, IconUserCircle } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import PlanBadge from "@/components/common/ui/badge/PlanBadge/PlanBadge";
import { crewStore, userStore } from "@/mobx/rootStore";
import { routesList } from "@/routesList";
import { logout } from "@/utils/auth/logout";
import { useHandleNavigate } from "@/utils/hooks/useHandleNavigate";
import { planQueries } from "@/utils/useQuery/queries/queries";
import { useFetchFromQuery } from "@/utils/useQuery/useFetch";

const SUPPORT_EMAIL = "support@economos.app";

/**
 * @returns {JSX.Element}
 */
export default observer(function UserInfo() {
	const { handleNavigate } = useHandleNavigate();

	const crewId = crewStore.getSelectedCrew("id");

	const { data: usageOverview } = useFetchFromQuery(planQueries.getUsage, {
		args: { crewId },
		enabled: Boolean(crewId),
	});

	return (
		<Stack gap="sm">
			<Group ml="xs" gap="xs">
				<IconUserCircle />
				<Text size="md">
					<Text span c="dimmed">
						<Trans>Usuario:&nbsp;</Trans>
					</Text>
					{userStore?.data?.username}
				</Text>
			</Group>

			<Button
				variant="subtle"
				leftSection={<IconBolt />}
				justify="flex-start"
				onClick={() => {
					handleNavigate(routesList.usage.path);
				}}
			>
				<Group gap="xs">
					<Text span size="md">
						<Trans>Plan:</Trans>
					</Text>
					<PlanBadge plan={usageOverview?.plan?.id} size="sm" />
				</Group>
			</Button>

			<Divider />

			<Button
				variant="subtle"
				leftSection={<IconSettings />}
				justify="flex-start"
				onClick={() => handleNavigate(routesList.settings.path)}
			>
				<Trans>Ajustes</Trans>
			</Button>

			<Button
				variant="subtle"
				leftSection={<IconMail />}
				color="green"
				justify="flex-start"
				onClick={() => window.open(`mailto:${SUPPORT_EMAIL}?subject=`, "_blank")}
			>
				<Trans>Contacto</Trans>
			</Button>

			<Button
				variant="subtle"
				color="red"
				leftSection={<IconLogout />}
				justify="flex-start"
				onClick={() => {
					logout({});
				}}
			>
				<Trans>Salir</Trans>
			</Button>
		</Stack>
	);
});
